const isValidHttpUrl = url => {
  if (!url || typeof url !== 'string') return false;

  // 1. Url' format validation with Regex
  const urlRegex = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;

  try {
    // 2. Url' protocol validation using URL constructor
    const urlObj = new URL(url);

    return urlRegex.test(url) && urlObj.protocol.startsWith('http');
  } catch {
    return false;
  }
};

export default isValidHttpUrl;
